var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardEventsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ticket-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1585 7.55853C16.7686 7.16845 16.5403 6.64553 16.5192 6.09436C16.4982 5.54319 16.686 5.00439 17.0451 4.58572C17.0748 4.5509 17.0902 4.50614 17.0883 4.46042C17.0864 4.41469 17.0673 4.37138 17.0348 4.33916L14.9662 2.26822C14.932 2.23404 14.8856 2.21484 14.8373 2.21484C14.7889 2.21484 14.7426 2.23404 14.7084 2.26822L11.4112 5.56541C11.2895 5.68703 11.1979 5.83533 11.1435 5.99853C11.0894 6.16212 10.9978 6.31083 10.8762 6.43288C10.7546 6.55493 10.6062 6.64696 10.4428 6.70166C10.2794 6.75608 10.131 6.84771 10.0092 6.96931L1.55338 15.4232C1.5192 15.4574 1.5 15.5038 1.5 15.5521C1.5 15.6005 1.5192 15.6468 1.55338 15.681L3.62197 17.7496C3.65419 17.7821 3.6975 17.8013 3.74323 17.8032C3.78895 17.8051 3.83371 17.7896 3.86853 17.7599C4.28711 17.4005 4.82603 17.2123 5.37739 17.2332C5.92875 17.2542 6.45187 17.4825 6.84203 17.8727C7.23218 18.2629 7.46057 18.786 7.48148 19.3373C7.50239 19.8887 7.31427 20.4276 6.95478 20.8462C6.92508 20.881 6.90964 20.9258 6.91155 20.9715C6.91347 21.0172 6.93259 21.0605 6.9651 21.0928L9.03369 23.1613C9.06788 23.1955 9.11425 23.2147 9.1626 23.2147C9.21094 23.2147 9.25731 23.1955 9.2915 23.1613L17.7478 14.7056C17.8694 14.5837 17.961 14.4353 18.0154 14.272C18.0696 14.1084 18.1611 13.9597 18.2827 13.8376C18.4044 13.7156 18.5528 13.6235 18.7162 13.5688C18.8794 13.5145 19.0277 13.4228 19.1493 13.3012L22.4465 10.004C22.4807 9.96981 22.4999 9.92344 22.4999 9.8751C22.4999 9.82675 22.4807 9.78038 22.4465 9.74619L20.3779 7.6776C20.3457 7.64509 20.3024 7.62597 20.2567 7.62405C20.2109 7.62214 20.1662 7.63758 20.1313 7.66728C19.7133 8.02699 19.1748 8.21562 18.6236 8.19546C18.0725 8.17529 17.5492 7.94783 17.1585 7.55853Z",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.7427 7.29734L10.9688 6.52344",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.8052 9.36133L13.2891 8.8457",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.8691 11.4263L15.3535 10.9102",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.1909 13.7466L17.417 12.9727",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardEventsIcon);
export default __webpack_public_path__ + "static/media/dashboard_events_icon.5257ded9b740e7013ed6d008090bd0b7.svg";
export { ForwardRef as ReactComponent };